module.exports = __webpack_public_path__ + "img/extension-new.0a0cbbb4.png";